var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"main-content"},[_c('el-alert',{staticClass:"black-bold",staticStyle:{"margin-bottom":"1em"},attrs:{"title":_vm.$t('SystemInfoTitle'),"type":"success"}}),_c('EDM'),_c('PC'),_c('Hardware')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }